import { render, staticRenderFns } from "./core-toolbar.vue?vue&type=template&id=6c7a7fec&"
import script from "./core-toolbar.vue?vue&type=script&lang=js&"
export * from "./core-toolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports